import React from "react";
import ReactMarkdown from "react-markdown";

const el = (Tag, className) => function MdElement({ node, ...props }) {
  return <Tag className={className} {...props} />;
};

const COMPONENTS = {
  p: el("p", "mb-2 last:mb-0"),
  ul: el("ul", "mb-2 list-disc space-y-1 pl-5 last:mb-0"),
  ol: el("ol", "mb-2 list-decimal space-y-1 pl-5 last:mb-0"),
  strong: el("strong", "font-semibold"),
  h1: el("h3", "mb-1.5 mt-3 font-display text-base font-semibold first:mt-0"),
  h2: el("h3", "mb-1.5 mt-3 font-display text-base font-semibold first:mt-0"),
  h3: el("h4", "mb-1 mt-3 font-display font-semibold first:mt-0"),
  blockquote: el("blockquote", "mb-2 border-l-2 border-primary/50 pl-3 text-muted-foreground last:mb-0"),
  hr: el("hr", "my-3 border-border"),
  code: el("code", "rounded bg-muted px-1 py-0.5 text-[0.85em]"),
  a: el("a", "text-primary underline underline-offset-2"),
};

export const CoachMarkdown = ({ children }) => (
  <div className="break-words leading-relaxed" data-testid="coach-markdown">
    <ReactMarkdown components={COMPONENTS}>{children}</ReactMarkdown>
  </div>
);
